import * as React from 'react';
import * as main from '../../main.module.scss';
import * as adv from './style.module.scss';
import licensesData from './licenses.json';
import { CarouselFullscreen } from '../../../../CarouselFullscreen';
export const Advance = () => {
  const [fullScreenState, setFullScreenState] = React.useState({ open: false, selectedSlideIndex: 0 });
  return (
    <section className={adv.adv}>
      <div className="container">
        <div className={adv.authors}>
          <h2 className={main.title}>Над курсом работали:</h2>
          <ul>
            <li>
              <img
                src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/author-zgoda.png"
                alt="Александр Згода"
              />
              <div>
                <h3>Александр Згода</h3>
                <p>Выпускающий редактор, автор упражнений, соавтор системы мотивации</p>
              </div>
            </li>
            <li>
              <img
                src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/author-lomakina.png"
                alt="Светлана Ломакина"
              />
              <div>
                <h3>Светлана Ломакина</h3>
                <p>Руководитель рабочей группы методистов</p>
              </div>
            </li>
            <li>
              <img
                src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/author-medvedeva.png"
                alt="Анна Медведева"
              />
              <div>
                <h3>Анна Медведева</h3>
                <p>Участник рабочей группы методистов</p>
              </div>
            </li>
          </ul>
        </div>
        <div className={adv.cot}>
          <h2 className={main.title}>Центр образовательных технологий Advance</h2>
          <div className={adv.inner}>
            <div className={adv.lic}>
              <div className={adv.wrap}>
                {licensesData.map((elem, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      setFullScreenState({ open: true, selectedSlideIndex: index });
                    }}
                  >
                    <img src={elem.imageSrc} alt={elem.title} />
                  </button>
                ))}
              </div>
              <p>Лицензии Advance на осуществление образовательной деятельности</p>
            </div>
            <div>
              <p>Мы — частная образовательная организация с курсами для детей и взрослых.</p>
              <p>
                В наших программах применяются авторские технологии развития когнитивных навыков: памяти, внимания,
                интеллектуальной выносливости, навыка самостоятельного обучения. Проще говоря, наши курсы помогают
                эффективнее учиться и работать и более того — делать это с удовольствием.
              </p>
              <p>
                С 2009 года наши курсы прошли 85 тысяч человек. Программа устроена так, чтобы учащийся не бросал учёбу,
                а дошёл до конца.
              </p>
              <p>
                Учащиеся работают на нашей образовательной платформе, которая разработана специально для прохождения
                таких программ.
              </p>
            </div>
          </div>
        </div>
      </div>

      <CarouselFullscreen
        data={licensesData.map((elem) => (
          <img className={adv.carousel} src={elem.imageSrc} alt={elem.title} />
        ))}
        open={fullScreenState.open}
        selectedSlideIndex={fullScreenState.selectedSlideIndex}
        onClose={() => {
          setFullScreenState({ open: false, selectedSlideIndex: 0 });
        }}
      />
    </section>
  );
};
